// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1_kha","cls2":"AiSummary-cls2_vFM AiSummary-cls1_kha"};